import { render } from "./BenchmarksModal.vue?vue&type=template&id=05730365&scoped=true"
import script from "./BenchmarksModal.vue?vue&type=script&lang=js"
export * from "./BenchmarksModal.vue?vue&type=script&lang=js"

import "./BenchmarksModal.vue?vue&type=style&index=0&id=05730365&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05730365"]])

export default __exports__